const languageMap = {
  JavaScript: "javascript",
  C: "c",
  "C++": "cpp",
  Python: "python",
  Java: "java",
  HTML: "html",
  CSS: "css",
  Ruby: "ruby",
  Go: "go",
  PHP: "php",
};

export default languageMap;
